import React from 'react';
import ReactDiffViewer from 'react-diff-viewer';

import {
  CreditAgreement,
  getCreditAgreementFullArtifactLabel,
} from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

type CreditAgreementWipDiffViewerProps = {
  creditAgreementFullArtifactWip: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  currentCreditAgreementFullArtifact: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
};
export const CreditAgreementWipDiffViewer = ({
  creditAgreementFullArtifactWip,
  currentCreditAgreementFullArtifact,
}: CreditAgreementWipDiffViewerProps) => {
  return (
    <ReactDiffViewer
      oldValue={JSON.stringify(currentCreditAgreementFullArtifact, null, 4)}
      newValue={JSON.stringify(creditAgreementFullArtifactWip, null, 4)}
      leftTitle={`Active Credit Agreement, ${getCreditAgreementFullArtifactLabel(
        currentCreditAgreementFullArtifact,
      )}`}
      rightTitle="WIP"
      splitView
      useDarkTheme
    />
  );
};
